// #1923: selectievakjes in het factuuroverzicht en in het tabblad Facturen van
// het sporterprofiel. Houdt de teller en de actiebalk bij, selecteert alle
// facturen op de pagina en biedt dan aan om alle gefilterde facturen te
// selecteren (het veld "alle" gaat dan naar de server, die het filter opnieuw
// toepast). Zonder JavaScript werken de vakjes en knoppen gewoon als formulier.
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["vak", "pagina", "balk", "teller", "banner", "bannerTekst", "alleKnop", "alleVeld", "menu"]
  static values = { een: String, meer: String, pagina: String, alles: String, totaal: Number }

  connect() {
    this.sluitMenus = this.sluitMenus.bind(this)
    document.addEventListener("click", this.sluitMenus)
    this.bijwerken()
  }

  disconnect() {
    document.removeEventListener("click", this.sluitMenus)
  }

  paginaKiezen(event) {
    this.vakTargets.forEach((vak) => { vak.checked = event.target.checked })
    this.alleVeldTarget.value = ""
    this.bijwerken()
  }

  wijzig() {
    this.alleVeldTarget.value = ""
    this.bijwerken()
  }

  alleGefilterd() {
    this.vakTargets.forEach((vak) => { vak.checked = true })
    this.alleVeldTarget.value = "1"
    this.bijwerken()
  }

  wis() {
    this.vakTargets.forEach((vak) => { vak.checked = false })
    this.alleVeldTarget.value = ""
    this.bijwerken()
  }

  bijwerken() {
    const gekozen = this.vakTargets.filter((vak) => vak.checked).length
    const alles = this.alleVeldTarget.value === "1"
    const aantal = alles ? this.totaalValue : gekozen
    const heelPagina = gekozen > 0 && gekozen === this.vakTargets.length

    this.vakTargets.forEach((vak) => vak.closest("tr")?.classList.toggle("fo-gekozen", vak.checked))
    if (this.hasPaginaTarget) {
      this.paginaTarget.checked = heelPagina
      this.paginaTarget.indeterminate = gekozen > 0 && !heelPagina
    }
    this.balkTarget.hidden = aantal === 0
    this.tellerTarget.textContent = aantal === 1 ? this.eenValue : this.meerValue.replace("__AANTAL__", aantal)

    if (this.hasBannerTarget) {
      const meerDanPagina = this.totaalValue > this.vakTargets.length
      this.bannerTarget.hidden = !(heelPagina && meerDanPagina)
      this.bannerTekstTarget.textContent = alles ? this.allesValue : this.paginaValue
      this.alleKnopTarget.hidden = alles
    }
  }

  // Sorteerkeuze op een smal scherm: de optie bevat het adres
  sorteer(event) {
    const adres = event.target.value
    if (window.Turbo) window.Turbo.visit(adres, { action: "advance" })
    else window.location.href = adres
  }

  sluitMenus(event) {
    this.menuTargets.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false
    })
  }
}
